$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/ndcc/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	// スクロールアニメーション
	// new WOW().init();
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_nav_btn').on('click', function () {
		body.toggleClass('open');
	});

	// エントリーフォームカタ自動補完
	$.fn.autoKana('#your-name', '#kana', {
		katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
	});

	// 住所自動入力
	$('#zip').attr("onKeyUp", "AjaxZip3.zip2addr(this,'','pref','address');");

	// 住所自動補完が完了したら
	AjaxZip3.onSuccess = function() {
		$('input[name=address]').focus(); // 番地、建物名にフォーカス
		// $('select[name=prefectures]').css({'color':'#000'}); //色変更
	};

	//グロナビ　アコーディオン
	$('.accordion_trigger').on('click', function () {
		if($(this).next(".accordion_content").hasClass('open')){
			$(this).removeClass('open');
			$(this).next(".accordion_content").removeClass('open');
		} else {
			$(this).addClass('open');
			$(".accordion_content").removeClass("open");
			$(this).next(".accordion_content").addClass('open');
		}
	});

	//よくあるご質問
	$('.faq_list dt').on('click', function () {
		$(this).toggleClass("open");
		$(this).next("dd").slideToggle();
		$(this).next("dd").toggleClass("open");
	});

	// youtube modal
	$('.modalVideoBtn').modalVideo({channel: 'youtube'});

});